const SkeletonWallet = () => {
  return (
    <div className="animate-pulse p-4">
      <div className="h-8 w-32 bg-gray-300 rounded mb-4"></div>

      <div className="w-full py-4">
        <div className="h-6 w-24 bg-gray-300 rounded mb-2"></div>
        <div className="h-10 w-40 bg-gray-400 rounded mb-4"></div>
        <div className="flex gap-3">
          <div className="h-10 w-24 bg-gray-300 rounded"></div>
          <div className="h-10 w-24 bg-gray-300 rounded"></div>
        </div>
      </div>

      <div className="mt-6 py-4 border border-gray-300 rounded-md">
        <div className="h-6 w-40 bg-gray-300 rounded mx-6 mb-3"></div>
        <div className="space-y-3 px-4">
          {[...Array(5)].map((_, index) => (
            <div
              key={index}
              className="flex justify-between items-center py-2 border-b last:border-b-0"
            >
              <div className="flex items-center gap-2">
                <div className="h-6 w-6 bg-gray-300 rounded-full"></div>
                <div className="h-4 w-20 bg-gray-300 rounded"></div>
              </div>
              <div className="h-4 w-16 bg-gray-300 rounded"></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SkeletonWallet